import React from 'react';
import {
    Typography,
    Stack,
    Box,
    Button,
    Dialog,
    Grid,
    AppBar,
    Tabs,
    Tab,
    DialogContent,
} from '@mui/material';
import { formatDate } from 'utils';
import { CountryList } from 'Services/CountryService';
import { TabPanel } from 'Components/Styled';
import {} from './BundleApi';
import BundleEditView from './BundleEditView';
import ProductSelector from './BundleProductSelector';
import BundleCardList from './BundleCardList';
import MicroexperienceSelector from './BundleMicroexperienceSelector';
import ModalDialogTitle from 'Components/ModalDialogTitle';
import { Link } from 'react-router-dom';
import { removeCardFromBundle, updateCardInBundle, saveBundle, addCardToBundle, getBundleById } from './BundleApi';
import CardDetailsView from './CardDetailView';
import BundleImagePicker from './BundleImagePicker';
import { useTheme } from '@emotion/react';
import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import HeroProductListView from './HeroProductListVIew';
import CameraswitchRoundedIcon from '@mui/icons-material/CameraswitchRounded';

export default function BundleDetailView({ bundleId }) {
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [bundle, setBundle] = React.useState({});

    async function loadBundle() {
        const data = await getBundleById(bundleId);
        setBundle(data);
    }

    React.useEffect(() => {
        (async () => {
            const data = await getBundleById(bundleId);
            setBundle(data);
        })();
    }, [bundleId]);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const [addCardVisible, setaddCardVisible] = React.useState(false);
    function onAddCardClicked() {
        setaddCardVisible(true);
    }

    function onAddNewCard(data) {
        (async () => {
            console.log({ addNewCard: { bundle, data } });
            await addCardToBundle(bundle, data);
            loadBundle();
            setaddCardVisible(false);
        })();
    }
    function onSaveCard(data) {
        (async () => {
            console.log({ onSaveCard: data });
            await updateCardInBundle(bundle, data);
            loadBundle();
            setaddCardVisible(false);
        })();
    }

    const [editBundleVisible, setEditBundleVisible] = React.useState(false);
    function onShowEditView() {
        setEditBundleVisible(true);
    }
    function onBundleUpdated(bundle) {
        (async () => {
            await saveBundle(bundle);
            loadBundle();
            setEditBundleVisible(false);
        })();
    }
    function handleAddClose() {
        setaddCardVisible(false);
    }

    function handleBundleEditClose() {
        setEditBundleVisible(false);
        loadBundle();
    }

    function onRemoveCard(card) {
        if (window.confirm('Confirm delete for ' + card.cardName + ' ?')) {
            (async () => {
                await removeCardFromBundle(bundle, card);
                loadBundle();
            })();
        }
    }

    function onEditCard(card) {
        setEditCardModal({ isVisible: true, card: card });
    }

    const [editCardModal, setEditCardModal] = React.useState({ isVisible: false, card: {} });

    function handleEditCardClose() {
        setEditCardModal({ isVisible: false, card: {} });
    }

    const [cardList, setCardList] = React.useState([]);
    React.useEffect(() => {
        if (!bundle?.cards?.length) {
            setCardList([]);
            return;
        }
        const list = [...bundle?.cards];
        list.sort((a, b) => a.sequenceNumber <= b.sequenceNumber);
        setCardList(list);
    }, [bundle]);

    function onUpdateRowPosition(initialIndex, newIndex, cards) {
        return (async () => {
            const cardsClone = [...cards];
            const row = cardsClone.splice(initialIndex, 1)[0];
            cardsClone.splice(newIndex, 0, row);
            cardsClone.forEach((c, index) => (c.sequenceNumber = index + 1));
            const newBundle = { ...bundle, cards: cardsClone };
            await saveBundle(newBundle);
            await loadBundle();
        })();
    }

    function onUpdateBundleSubscriptionStatus(cardId, subType, value) {
        (async () => {
            const newBundle = { ...bundle };
            const card = newBundle.cards?.find((c) => c.cardId === cardId);
            const sub = card?.subscriptionMap?.find((s) => s.subscriptionTierCode === subType);
            sub.isAvailable = value;
            await saveBundle(newBundle);
            await loadBundle();
        })();
    }

    const [imagePickerVisible, setImagePickerVisible] = React.useState(false);
    function handleCloseImagePicker() {
        setImagePickerVisible(false);
    }
    function onShowImagePicker() {
        setImagePickerVisible(true);
    }
    function onSelectImage(imageData) {
        (async () => {
            handleCloseImagePicker();
            const newBundle = { ...bundle };
            newBundle.primaryImage = imageData;
            await saveBundle(newBundle);
            await loadBundle();
        })();
    }

    const theme = useTheme();

    return (
        <>
            <Dialog open={imagePickerVisible} onClose={handleCloseImagePicker} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={handleCloseImagePicker}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <BundleImagePicker bundle={bundle} onSelectImage={onSelectImage} onClose={handleCloseImagePicker} />
                </DialogContent>
            </Dialog>
            <Dialog open={addCardVisible} onClose={handleAddClose} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={handleAddClose}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <AddCardView onSaveCard={onAddNewCard} onClose={handleAddClose} />
                </DialogContent>
            </Dialog>
            <Dialog open={editCardModal.isVisible} onClose={handleEditCardClose} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={handleEditCardClose}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <EditCardView card={editCardModal.card} onSaveCard={onSaveCard} onClose={handleEditCardClose} />
                </DialogContent>
            </Dialog>

            <Dialog open={editBundleVisible} onClose={handleBundleEditClose} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={handleBundleEditClose}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <BundleEditView bundle={bundle} onBundleUpdated={onBundleUpdated} onClose={handleBundleEditClose} />
                </DialogContent>
            </Dialog>

            <Stack direction="column" height="100vh" flex={1} overflow="hide" margin={0}>
                <Link to="/bundles">
                    <Typography variant="h2" sx={{ color: theme.palette.amazingco.pink }}>
                        &lt; Back to search
                    </Typography>
                </Link>
                <Typography variant="h1">{bundle.bundleName} </Typography>
                <Stack direction="row" flex={1}>
                    <Box width={300}>
                        <DetailSumnmaryView
                            bundle={bundle}
                            onShowEditView={onShowEditView}
                            onShowImagePicker={onShowImagePicker}
                        />
                    </Box>
                    <Box sx={{ justifySelf: 'stretch', flex: 1 }}>
                        <AppBar position="static">
                            <Tabs value={selectedTab} onChange={handleTabChange}>
                                <Tab style={{ textTransform: 'capitalize' }} label="Bundle Cards" {...a11yProps(0)} />
                                <Tab
                                    style={{ textTransform: 'capitalize' }}
                                    label="Relationship"
                                    {...a11yProps(1)}
                                />
                                <Tab disabled style={{ textTransform: 'capitalize' }} label="Other" {...a11yProps(3)} />
                                <Tab disabled style={{ textTransform: 'capitalize' }} label="Notes" {...a11yProps(4)} />
                                <Tab style={{ textTransform: 'capitalize' }} label="Data" {...a11yProps(4)} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={selectedTab} index={0} sx={{ display: 'flex', flex: 1 }}>
                            <Stack direction="column" sx={{ flex: 1 }}>
                                <DetailCardListView
                                    cardList={cardList}
                                    onAddCardClicked={onAddCardClicked}
                                    onRemoveCard={onRemoveCard}
                                    onEditCard={onEditCard}
                                    onUpdateRowPosition={onUpdateRowPosition}
                                    onUpdateBundleSubscriptionStatus={onUpdateBundleSubscriptionStatus}
                                />
                            </Stack>
                        </TabPanel>
                        <TabPanel value={selectedTab} index={1} sx={{ display: 'flex', flex: 1 }}>
                            <Stack direction="column" sx={{ flex: 1 }}>
                                <HeroProductListView
                                    bundle={bundle}
                                />
                            </Stack>
                        </TabPanel>
                        <TabPanel value={selectedTab} index={2}>
                            Other
                        </TabPanel>
                        <TabPanel value={selectedTab} index={3}>
                            Notes
                        </TabPanel>
                        <TabPanel value={selectedTab} index={5}>
                            <pre>{JSON.stringify({ bundle }, null, 2)}</pre>
                        </TabPanel>
                    </Box>
                </Stack>
            </Stack>
        </>
    );
}

function DetailSumnmaryView({ bundle, onShowEditView, onShowImagePicker }) {
    // function formatValidDate(bundle) {
    //     const startDate = moment(bundle.validStartDate);
    //     const endDate = moment(bundle.validEndDate);

    //     return startDate.format('DD MMM YY') + ' - ' + endDate.format('DD MMM YY');
    // }

    function formatLocation(bundle) {
        const country = CountryList.find((o) => o.code === bundle.country);
        return country?.display || 'INVALID';
    }

    function editBundle(bundle) {
        onShowEditView();
    }

    return (
        <Stack direction="column">
            <DetailImageView bundle={bundle} onShowImagePicker={onShowImagePicker} />
            <Grid container>
                <Grid xs={4}> Bundle ID</Grid>
                <Grid xs={8}> {bundle.id}</Grid>
                <Grid xs={4}> Location</Grid>
                <Grid xs={8}> {formatLocation(bundle)}</Grid>
                <Grid xs={4}> Type</Grid>
                <Grid xs={8}>{bundle.bundleType}</Grid>
                <Grid xs={4}> Status</Grid>
                <Grid xs={8}>{bundle.statusCode}</Grid>
                <Grid xs={4}> Created</Grid>
                <Grid xs={8}> {formatDate(bundle.createdDateTime)}</Grid>
                <Grid xs={4}> Modified</Grid>
                <Grid xs={8}> {formatDate(bundle.updatedDateTime)}</Grid>
                <Grid xs={12}>
                    <Button onClick={(e) => editBundle(bundle)} variant="contained" color="primary">
                        Edit
                    </Button>
                </Grid>
            </Grid>
        </Stack>
    );
}

function DetailImageView({ bundle, onShowImagePicker }) {
    // const theme = useTheme();

    return (
        <Stack direction="column" spacing={12} sx={{ mt: 16, mb: 12 }}>
            <Box
                fullWidth
                sx={{
                    mr: 12,
                    mb: 0,
                    minHeight: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {!!bundle?.primaryImage?.thumbnailUrl && (
                    <Stack direction='column'>
                    <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        border: '1px solid #ddd',
                        borderRadius: '12px',
                        alignItems: 'center',
                        minHeight: '200px',
                    }}
                >

<img
                        alt=""
                        src={bundle?.primaryImage?.thumbnailUrl}
                        style={{
                            width: '100%',
                            minHeight: 200,
                            objectFit: 'cover',
                            border: '1px solid #ddd',
                            borderRadius: '12',
                        }}
                    />
                    </Box>
                    <CameraswitchRoundedIcon
                    onClick={() => {
                        onShowImagePicker();
                    }}
                />
</Stack>                
    
                )}
                {!bundle?.primaryImage?.thumbnailUrl && (
                    <Box
                        sx={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            border: '1px solid #ddd',
                            borderRadius: '12px',
                            alignItems: 'center',
                            minHeight: '200px',
                        }}
                    >
                        <FileUploadIcon
                            onClick={() => {
                                onShowImagePicker();
                            }}
                        />
                        <Typography>Upload</Typography>
                    </Box>
                )}
            </Box>
        </Stack>
    );
}

function DetailCardListView({
    cardList,
    onAddCardClicked,
    onRemoveCard,
    onEditCard,
    onUpdateRowPosition,
    onUpdateBundleSubscriptionStatus,
}) {
    function addClicked() {
        onAddCardClicked();
    }

    return (
        <Stack direction="column" sx={{ flex: 1 }}>
            <Stack direction="row" justifyContent="flex-end">
            <Button variant="contained" onClick={addClicked} startIcon={<AddIcon/>}>
                     Add New Card</Button>                
            </Stack>
            <BundleCardList
                cardList={cardList}
                onRemoveCard={onRemoveCard}
                onEditCard={onEditCard}
                onUpdateRowPosition={onUpdateRowPosition}
                onUpdateBundleSubscriptionStatus={onUpdateBundleSubscriptionStatus}
            />
        </Stack>
    );
}

function AddCardView({ onSaveCard, onClose }) {
    const [cardStep, setCardStep] = React.useState('NEW_CARD');
    const [selectedObject, setSelectedObject] = React.useState({ type: undefined, data: {} });

    function onCardTypeSelected(selectedType) {
        setCardStep('SELECT_' + selectedType);
    }

    function onCardObjectSelected(newCard) {
        setSelectedObject(newCard);
    }

    React.useEffect(() => {
        if (selectedObject?.cardType) {
            setCardStep('NEW_CARD_DETAILS');
        }
    }, [selectedObject]);

    function onBackClicked() {
        setCardStep('SELECT_' + selectedObject.cardType);
        setSelectedObject({});
    }

    switch (cardStep) {
        case 'NEW_CARD_DETAILS':
            return (
                <CardDetailsView
                    card={selectedObject}
                    onClose={onClose}
                    onSaveCard={onSaveCard}
                    onBackClicked={onBackClicked}
                />
            );
        case 'SELECT_PRODUCT':
            return <ProductSelector onCardObjectSelected={onCardObjectSelected} />;
        case 'SELECT_MICROEXPERIENCE':
            return <MicroexperienceSelector onCardObjectSelected={onCardObjectSelected} />;
        case 'NEW_CARD':
        default:
            return <CardTypeSelector onCardTypeSelected={onCardTypeSelected} />;
    }
}

function CardTypeSelector({ onCardTypeSelected }) {
    return (
        <Stack direction="row" justifyContent="space-between" sx={{ alignSelf: 'centre', margin: 'auto' }} spacing={40}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => onCardTypeSelected('PRODUCT')}
                sx={{ height: 180, width: 180 }}
            >
                Product
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={() => onCardTypeSelected('MICROEXPERIENCE')}
                sx={{ height: 180, width: 180 }}
            >
                MicroExperience
            </Button>
        </Stack>
    );
}

function EditCardView({ card, onSaveCard, onClose }) {
    return <CardDetailsView card={card} onClose={onClose} onSaveCard={onSaveCard} />;
}
